import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var suggestionOfferSchema = {
    product: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control'
        }),
        elementType: 'autocomplete',
        label: 'Продукт',
        value: null,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден продукт',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
};
export default suggestionOfferSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/suggestionOfferSchema.ts
// module id = 482
// module chunks = 0